import { writable } from "svelte/store";

// Page size shared by the masks and elements level of the anonymization check,
// so it stays when switching levels and survives a reload in the same session.
const STORAGE_KEY = "anonymizationCheckPageSize";

function readStoredSize() {
  try {
    return sessionStorage.getItem(STORAGE_KEY) || "10";
  } catch {
    return "10";
  }
}

export const anonymizationPageSize = writable(readStoredSize());

anonymizationPageSize.subscribe((value) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, value);
  } catch {
    // Without storage the size is still shared while the page is open.
  }
});
